import React from "react";

export function RectangleIcon() {
    return (
        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.82904 11.7071C1.41062 12.0976 0.732233 12.0976 0.313814 11.7071C-0.0767101 11.3426 -0.102745 10.7668 0.235709 10.3741L0.313814 10.2929L4.41339 6L0.313814 1.70711C-0.0767101 1.34262 -0.102745 0.766761 0.235709 0.374089L0.313814 0.292893C0.704338 -0.0715959 1.32133 -0.0958953 1.74205 0.219995L1.82904 0.292893L6.68619 5.29289C7.07671 5.65738 7.10275 6.23324 6.76429 6.62591L6.68619 6.70711L1.82904 11.7071Z" fill="#3EC1CB"/>
        </svg>
    );
}
